if (!customElements.get('product-recommendation-properties')) {
    class ProductRecommendationProperties extends HTMLElement {
    static observedAttributes = ['product-id', 'intent'];

    connectedCallback() {
        this.load();
    }

    attributeChangedCallback() {
        if (this.isConnected) this.load();
    }

    async load() {
        const productId = this.getAttribute('product-id');
        const intent = this.getAttribute('intent') || 'complementary';
        const inputName =
        this.getAttribute('input-name') ||
        'properties[_recommended_product_handles]';

        if (!productId) return;

        const cacheKey = `${productId}:${intent}`;
        if (this.dataset.cacheKey === cacheKey) return;

        this.dataset.cacheKey = cacheKey;

        const root = window.Shopify?.routes?.root || '/';
        const url =
        `${root}recommendations/products.json` +
        `?product_id=${encodeURIComponent(productId)}` +
        `&intent=${encodeURIComponent(intent)}`;

        try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Recommendation request failed: ${response.status}`);
        }

        const data = await response.json();

        const handles = (data.products || [])
            .map(product => product.handle)
            .filter(Boolean)
            .slice(0, 6);

        this.renderInput(inputName, handles);
        } catch (error) {
        console.error(error);
        this.renderInput(inputName, []);
        }
    }

    renderInput(name, handles) {
        let input = this.querySelector('input[type="hidden"]');

        if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        this.append(input);
        }

        input.name = name;
        input.value = handles.join(',');
        input.disabled = handles.length === 0;
    }
    }

  customElements.define(
    'product-recommendation-properties',
    ProductRecommendationProperties
  );
}